/*
 * @Description: '结局方案'页面所有路由
 * @Author: mike ma *
 * @Date: 2021-02-27 16:50:00
 * @LastEditTime: 2021-02-27 20:12:42
*/

export default [
    {
        path: 'sports',
        component: resolve => require(['@/views/sports'], resolve),
        name: 'Sports',
        meta: {
            nav: '体育活动'
        }
    },   {
        path: 'sports/:id',
        component: resolve => require(['@/views/sports/detail'], resolve),
        name: 'Sports_detail',
        meta: {
            nav: '活动中心'
        }
    }

]



// WEBPACK FOOTER //
// ./src/router/sports.js